/**
 * Domain validation utilities for organization and root domains
 */

import {
  ORG_DOMAIN_PATTERN,
  ORG_DOMAIN_MIN_LENGTH,
  ROOT_DOMAIN_PATTERN,
} from "./domain-patterns"

/**
 * Validates an organization subdomain
 * @param orgDomain The organization domain to validate
 * @returns null if valid, error message string if invalid
 */
export function validateOrgDomain(orgDomain: string): string | null {
  // Require at least minimum length for the domain
  if (
    orgDomain.length < ORG_DOMAIN_MIN_LENGTH ||
    !ORG_DOMAIN_PATTERN.test(orgDomain)
  ) {
    return `Invalid organization domain: "${orgDomain}". Domains must be at least ${ORG_DOMAIN_MIN_LENGTH} characters, start and end with alphanumeric characters, and may contain hyphens (but not consecutive hyphens or at start/end).`
  }
  return null
}

/**
 * Validates a root domain (e.g., example.com)
 * @param rootDomain The root domain to validate
 * @returns true if valid, false otherwise
 */
export function isValidRootDomain(rootDomain: string): boolean {
  return ROOT_DOMAIN_PATTERN.test(rootDomain)
}
